
import { controls } from "../controls";


const benificiarydetails = {
  label: "Benificiary Details",
  pageLabel: "Benificiary Details",
  starting: true,
  url: "benificiarydetails",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [
    ...controls.displayText({label:"Sponsor Bank",width:"col-sm-2",star: true}),
    ...controls.BankCode({width:"col-sm-2",isRequired:true}),
    ...controls.displayText({width:"col-sm-2"}),
    ...controls.displayText({label:"Sponsor Bank Name",width:"col-sm-2"}),
    ...controls.showData({width:"col-sm-2",data:"sponsor_bank_name"}),
    ...controls.displayText({width:"col-sm-2"}),
    ...controls.displayText({label:"Tansaction Type",width:"col-sm-2",star: true}),
    ...controls.TransactionType({width:"col-sm-2",isRequired:true}),
    ...controls.displayText({width:"col-sm-2"}),
    ...controls.displayText({label:"Benificairy Details",width:"col-sm-2"}),
    ...controls.showData({width:"col-sm-2",data:"benificairy_details"}),
    ...controls.displayText({width:"col-sm-2"}),
    ...controls.displayText({label:"Benificairy Name",width:"col-sm-2",star: true}),
    ...controls.text({width:"col-sm-2",data:"benificairy_name",placeHolder:"Name",isRequired:true}),
    ...controls.displayText({width:"col-sm-2"}),
    ...controls.displayText({label:"Benificairy Account number",width:"col-sm-2",star: true}),
    ...controls.text({width:"col-sm-2",name:"benificairy_account_number",placeHolder:"Benificairy Account number",isRequired:true}),
    ...controls.displayText({width:"col-sm-2"}),
    ...controls.displayText({label:"Re-enter Account number",width:"col-sm-2",star: true}),
    ...controls.text({width:"col-sm-2",name:"re_enter_account_number",placeHolder:"Re-enter Account number",isRequired:true}),
    ...controls.displayText({width:"col-sm-2"}),
    ...controls.displayText({label: "Account Type",width:"col-sm-2 ",star: true}),
    ...controls.AccountType({width: "col-sm-2" ,isRequired:true}),
    ...controls.displayText({width:"col-sm-2"}),
    ...controls.displayText({label:"Comments",width:"col-sm-2",star: true}),
    ...controls.text({width:"col-sm-4",name:"comments",placeHolder:"Comments",isRequired:true}),
    ...controls.displayText({width:"col-sm-6"}),
    ...controls.displayText({ style: { textAlign: 'right' }, label: "Amount", width: "col-sm-2" ,star: true}),
    ...controls.numtoword({
       name: "entered_amount", width: "col-sm-2",isRequired:true  
    }),
    ...controls.numtoword({
        name: "amount1", width: "col-sm-1",  
      }),
      ...controls.numtoword({
        name: "amount2", width: "col-sm-1",  
      }),
      ...controls.displayText({ style: { textAlign: 'right' }, label: "Total Amount", width: "col-sm-2",star: true }),
      ...controls.numtoword({
         name: "total_amount", width: "col-sm-2", isRequired:true 
      }),
      ...controls.displayText({width:"col-sm-2"}),

      ...controls.displayText({label:"Benificairy Bank Details",width:"col-sm-2"}),
      ...controls.showData({width:"col-sm-2",data:"benificairy_bank_details"}),
      ...controls.displayText({width:"col-sm-8"}),
      ...controls.displayText({width:"col-sm-2",label:"IFSC Code",star: true}),
      ...controls.IfscCode({width:"col-sm-2",isRequired:true}),
      ...controls.displayText({width:"col-sm-8"}),
      ...controls.displayText({width:"col-sm-2",label:"Bank Name"}),
      ...controls.showData({width:"col-sm-4",data:"ifsccode_display"}),
      ...controls.displayText({width:"col-sm-6"}),
      ...controls.displayText({width:"col-sm-2",label:"Branch Name"}),
      ...controls.showData({width:"col-sm-4",data:"ifsc_bankname"}),
      ...controls.displayText({width:"col-sm-6"}),
      ...controls.displayText({width:"col-sm-2",label:"Bank Address"}),
      ...controls.showData({width:"col-sm-4",data:"ifsccode_address"}),
      ...controls.displayText({width:"col-sm-6"}),
      ...controls.displayText({width:"col-sm-2",label:"Email Address"}),
      ...controls.text({width:"col-sm-2",name:"email",placeHolder:"Email Address"}),

    


  ]
}

export default benificiarydetails;